import { z } from 'zod';
export const nonNegativeInt = (label) => z
    .number()
    .int(`${label} must be a whole number.`)
    .min(0, `${label} must be a non-negative whole number.`);
//# sourceMappingURL=non-negative-int.js.map